import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  CircularProgress,
  TablePagination,
  Box,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { Edit, Delete, Search } from "@mui/icons-material";
import { API_BASE_URL } from "../../../constant/constant";
import { decrypt } from "../../../components/cryptoUtil";
import { Heading } from "../../componenet/heading";

const weekDays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

function DoctorsList() {
  const decryptedData = JSON.parse(decrypt(localStorage.getItem("tokenData")));
  const token = localStorage.getItem("token");
  const hospitalId = decryptedData.softsubgroup;



  //console.log(hospitalId);
  const [doctors, setDoctors] = useState([]);
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const [specializations, setSpecializations] = useState([]);
  const [loadingSpecializations, setLoadingSpecializations] = useState(true);
  const [searchText, setSearchText] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [editOpen, setEditOpen] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);

  // Fetch doctors
  useEffect(() => {
    fetchDoctors();
  }, []);

  const fetchDoctors = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/hospital/listdoctors/${hospitalId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });


      const data = await res.json();
     //console.log(data)
      setDoctors(data);
      setFilteredDoctors(data);
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Failed to fetch doctors",
        severity: "error",
      });
    }
  };

  // Fetch specializations
  useEffect(() => {
    let mounted = true;
    const fetchSpecializations = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/hospital/specialization`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (mounted && Array.isArray(data)) setSpecializations(data);
      } catch (err) {
        console.error("Error fetching specializations:", err);
        setSnackbar({
          open: true,
          message: "Failed to load specializations",
          severity: "error",
        });
      } finally {
        setLoadingSpecializations(false);
      }
    };
    fetchSpecializations();
    return () => (mounted = false);
  }, [token]);

  // Handle search
  const handleSearch = () => {
    const filtered = doctors.filter((doc) => {
      const specializationName =
        specializations.find((s) => s.code === doc.specialization)?.name || "";
      return (
        doc.name.toLowerCase().includes(searchText.toLowerCase()) ||
        specializationName.toLowerCase().includes(searchText.toLowerCase())
      );
    });
    setFilteredDoctors(filtered);
    setPage(0); // Reset to first page
  };

  const availableServices = ["IPD", "OPD", "Emergency"];

  const handleServicesChange = (e) => {
    const { target: { value } } = e;
    setDoctors((prev) => ({
      ...prev,
      services: Array.isArray(value) ? value.join(",") : value,
    }));
  };




  const handleDelete = async (doctorId) => {
    if (!window.confirm("Are you sure you want to delete this doctor?")) return;
    try {
      const res = await fetch(`${API_BASE_URL}/api/hospital/deletedoctor/${doctorId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.ok) {
        setSnackbar({
          open: true,
          message: "Doctor deleted successfully",
          severity: "success",
        });
        fetchDoctors();
      } else {
        setSnackbar({
          open: true,
          message: "Error deleting doctor",
          severity: "error",
        });
      }
    } catch (err) {
      console.error(err);
      setSnackbar({ open: true, message: "Server error", severity: "error" });
    }
  };

  const handleEditOpen = (doctor) => {
    setSelectedDoctor({ ...doctor, schedule: doctor.schedule || [] });
    setEditOpen(true);
  };

  const handleEditChange = (e) => {
     const { name, value } = e.target;
      if (name === "mobile") {
    // Only digits, max 10
    const onlyDigits = value.replace(/\D/g, "");
    if (onlyDigits.length <= 10) {
      setSelectedDoctor((prev) => ({ ...prev, mobile: onlyDigits }));
    }
    return;
  }
  // Default case for other fields
  setSelectedDoctor((prev) => ({ ...prev, [name]: value }));
   // setSelectedDoctor({ ...selectedDoctor, [e.target.name]: e.target.value });
  };

  const handleScheduleChange = (index, field, value) => {
    const newSchedule = [...selectedDoctor.schedule];
    newSchedule[index][field] = value;
    setSelectedDoctor({ ...selectedDoctor, schedule: newSchedule });
  };

  const handleAddSchedule = () => {
    const newSchedule = [
      ...(selectedDoctor.schedule || []),
      { day_of_week: "", start_time: "", end_time: "" },
    ];
    setSelectedDoctor({ ...selectedDoctor, schedule: newSchedule });
  };

  const handleRemoveSchedule = (index) => {
    const newSchedule = selectedDoctor.schedule.filter((_, i) => i !== index);
    setSelectedDoctor({ ...selectedDoctor, schedule: newSchedule });
  };


  // Pagination handlers



useEffect(() => {
  const filtered = doctors.filter((doc) => {
    const specializationName =
      specializations.find((s) => s.code === doc.specialization)?.name || "";
    return (
      doc.name.toLowerCase().includes(searchText.toLowerCase()) ||
      specializationName.toLowerCase().includes(searchText.toLowerCase())
    );
  });
  setFilteredDoctors(filtered);
  setPage(0); // Reset to first page
}, [searchText, doctors, specializations]);





  const handleEditSave = async () => {
    try {
      // Attach hospital_code to each schedule entry
      //console.log(selectedDoctor);
      const updatedDoctor = {
        ...selectedDoctor,
        schedule: selectedDoctor.schedule.map((s) => ({
          ...s,
          hospital_code: hospitalId,   // match DB column
        })),
      };

     // console.log("Sending doctor update:", updatedDoctor);

      const res = await fetch(
        `${API_BASE_URL}/api/hospital/updatedoctor/${selectedDoctor.doctor_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(updatedDoctor), // send updatedDoctor instead of selectedDoctor
        }
      );
const data = await res.json();
      if (res.ok) {
        setSnackbar({
          open: true,
          message: "Doctor updated successfully",
          severity: "success",
        });
        setEditOpen(false);
        fetchDoctors();
      } else {
        setSnackbar({
          open: true,
          message: data.message || "Failed to add doctor",
          severity: "error",
        });
      }
    } catch (err) {
      console.error(err);
      setSnackbar({ open: true, message: "Server error", severity: "error" });
    }
  };




  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  return (
    <Card sx={{ maxWidth: 1200, mx: 'auto', mt: 4, boxShadow: 4 }}>
      <CardContent>
        <Heading headingtext="👨‍⚕️ Manage Doctors" />
        {/* 🔹 Search */}
        {/* <div style={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
          <TextField
            label="Search by Name or Specialization"
            variant="outlined"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            fullWidth
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleSearch}
            startIcon={<Search />}
          >
            Search
          </Button>
        </div> */}

{/* 🔹 Search */}
{/* <div style={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
  <TextField
    label="Search by Name or Specialization"
    variant="outlined"
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    onKeyDown={(e) => {
      if (e.key === "Enter") {
        handleSearch();
      }
    }}
    fullWidth
  />
</div> */}


<div style={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
  <TextField
    label="Search by Name or Specialization"
    variant="outlined"
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    fullWidth
  />
</div>



        <Box
          sx={{
            // maxHeight: "100vh",      // adjust height
            overflowY: "auto",   // vertical scroll
            mb: 2,
            border: "1px solid #ccc", // optional
          }}
        >
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#1976d2' }}>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Name</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Specialization</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Degree</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Fees</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Mobile</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Email</TableCell>
                {/* <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Schedule</TableCell> */}
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredDoctors
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((doc) => (
                  <TableRow key={doc.doctor_id}>
                    <TableCell>{doc.name}</TableCell>
                    <TableCell>
                      {specializations.find(
                        (s) => s.code === doc.specialization
                      )?.name || doc.specialization}
                    </TableCell>
                    <TableCell>{doc.degree}</TableCell>
                    <TableCell>{doc.fees}</TableCell>
                    <TableCell>{doc.mobile}</TableCell>
                    <TableCell>{doc.email}</TableCell>
                    {/* <TableCell>
                      {doc.schedule && doc.schedule.length > 0
                        ? doc.schedule.map((s, i) => (
                          <div key={i}>
                            {s.day_of_week}: {s.start_time} - {s.end_time}
                          </div>
                        ))
                        : "No Schedule"}
                    </TableCell> */}
                    <TableCell>
                      <IconButton
                        color="primary"
                        onClick={() => handleEditOpen(doc)}
                      >
                        <Edit />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => handleDelete(doc.doctor_id)}
                      >
                        <Delete />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Box>
        {/* Pagination */}
        <TablePagination
          component="div"
          count={filteredDoctors.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5,10, 25, 50, 100]}
        />

        {/* Edit Dialog */}
        <Dialog
          open={editOpen}
          onClose={() => setEditOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Edit Doctor</DialogTitle>
          <DialogContent>
            {selectedDoctor && (
              <>
                <TextField
                  margin="dense"
                  label="Name"
                  name="name"
                  value={selectedDoctor.name}
                  onChange={handleEditChange}
                  fullWidth
                />
                {loadingSpecializations ? (
                  <CircularProgress size={24} sx={{ my: 2 }} />
                ) : (
                  <TextField
                    margin="dense"
                    select
                    label="Specialization"
                    name="specialization"
                    value={selectedDoctor.specialization}
                    onChange={handleEditChange}
                    fullWidth
                  >
                    {specializations.map((spec) => (
                      <MenuItem key={spec.code} value={spec.code}>
                        {spec.name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
                <TextField
                  margin="dense"
                  label="Degree"
                  name="degree"
                  value={selectedDoctor.degree}
                  onChange={handleEditChange}
                  fullWidth
                />




 <TextField
                  margin="dense"
                  label="Reg. No."
                  name="reg_no"
                  value={selectedDoctor.reg_no}
                  onChange={handleEditChange}
                  fullWidth
                />


                <TextField
                  margin="dense"
                  label="Address"
                  name="address"
                  value={selectedDoctor.address}
                  onChange={handleEditChange}
                  fullWidth
                />




                <TextField
                  margin="dense"
                  label="Fees"
                  name="fees"
                  type="text"
                  value={selectedDoctor.fees}
                  onChange={(e) => {
    let value = e.target.value;
    // Remove non-numeric characters
    value = value.replace(/\D/g, "");
    // Enforce max length 5
    if (value.length > 5) {
      value = value.slice(0, 5);
    }

    handleEditChange({ target: { name: "fees", value } });
  }}

inputProps={{
    maxLength: 5,
    inputMode: "numeric",
    pattern: "[0-9]*",
  }}



                  fullWidth
                />





                <TextField
                  margin="dense"
                  label="Mobile"
                  name="mobile"
                  type="number"
                  value={selectedDoctor.mobile}
                  onChange={handleEditChange}
                  fullWidth
                />

 <TextField
                  margin="dense"
                  label="Emergency Contact"
                  name="emergency_contact"
                  type="number"
                  value={selectedDoctor.emergency_contact}
                  onChange={handleEditChange}
                  fullWidth
                />

                <TextField
                  margin="dense"
                  label="Email"
                  name="email"
                  value={selectedDoctor.email}
                  onChange={handleEditChange}
                  fullWidth
                />

                {/* <TextField
                  select
                  fullWidth
                  label="⏱ Services"
                  name="dutyType"
                  value={selectedDoctor.dutyType ? selectedDoctor.dutyType.split(",") : []} // safe
                  onChange={(e) => {
                    const { target: { value } } = e;
                    setSelectedDoctor((prev) => ({
                      ...prev,
                      dutyType: Array.isArray(value) ? value.join(",") : value,
                    }));
                  }}
                  margin="normal"
                  SelectProps={{ multiple: true, renderValue: (selected) => selected.join(", ") }}
                >
                  {availableServices.map((service) => (
                    <MenuItem key={service} value={service}>
                      <Checkbox
                        checked={selectedDoctor.dutyType?.split(",").includes(service) || false}
                      />
                      <ListItemText primary={service} />
                    </MenuItem>
                  ))}
                </TextField>

 */}




                {/* <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                  OPD Schedule
                </Typography>
                {selectedDoctor.schedule?.map((s, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      gap: "8px",
                      marginBottom: "8px",
                      alignItems: "center",
                    }}
                  >
                    <TextField
                      select
                      label="Day"
                      value={s.day_of_week}
                      onChange={(e) =>
                        handleScheduleChange(i, "day_of_week", e.target.value)
                      }
                      sx={{ flex: 1 }}
                    >
                      {weekDays.map((day) => (
                        <MenuItem key={day} value={day}>
                          {day}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      label="Start Time"
                      type="time"
                      value={s.start_time}
                      onChange={(e) =>
                        handleScheduleChange(i, "start_time", e.target.value)
                      }
                      sx={{ flex: 1 }}
                      InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                      label="End Time"
                      type="time"
                      value={s.end_time}
                      onChange={(e) =>
                        handleScheduleChange(i, "end_time", e.target.value)
                      }
                      sx={{ flex: 1 }}
                      InputLabelProps={{ shrink: true }}
                    />
                    <Button
                      color="error"
                      onClick={() => handleRemoveSchedule(i)}
                    >
                      Remove
                    </Button>
                  </div>
                ))}
                <Button onClick={handleAddSchedule}>➕ Add Schedule</Button> */}
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditOpen(false)}>Cancel</Button>
            <Button
              onClick={handleEditSave}
              variant="contained"
              color="primary"
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
        </Snackbar>
      </CardContent>
    </Card>
  );
}

export default DoctorsList;
